import { Form, Formik, type FormikHelpers } from "formik";
import { number, object } from "yup";
// @ts-expect-error pure js
import { useEdlSharedItems } from "../../hooks/use-edl-items";
// @ts-expect-error pure js
import { ReactSelect } from "../UI/Select";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Text from "../UI/Text";
import ModalDialog, { ModalDialogFooter } from "../UI/ModalDialog";
import Callout from "../UI/Callout";
import styles from "./EdlAddSharedItem.module.css";

interface EdlSharedItem {
  id: number;
  nom: string;
}

interface EdlAddSharedItemFormValues {
  id: number | string;
}

interface EdlAddSharedItemProps {
  currentItems: { id: number }[];
  onSubmit: (
    values: EdlAddSharedItemFormValues,
    helpers: FormikHelpers<EdlAddSharedItemFormValues>,
  ) => void | Promise<void>;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function EdlAddSharedItem({
  currentItems,
  onSubmit,
  open,
  onOpenChange,
}: EdlAddSharedItemProps) {
  const { edlSharedItems }: { edlSharedItems: EdlSharedItem[] } =
    useEdlSharedItems();

  const availableOptions = edlSharedItems
    .filter((item) => !currentItems.some((current) => current.id === item.id))
    .map((item) => ({ value: item.id, label: item.nom }));

  return (
    <Formik<EdlAddSharedItemFormValues>
      initialValues={{ id: "" }}
      enableReinitialize={true}
      validationSchema={object({
        id: number().required("Veuillez sélectionner une pièce partagée"),
      })}
      onSubmit={onSubmit}
    >
      {({ resetForm }) => (
        <ModalDialog
          size="md"
          open={open}
          header="Gestion des pièces partagées"
          onOpenChange={(nextOpen) => {
            if (!nextOpen) resetForm();
            onOpenChange(nextOpen);
          }}
        >
          <Form>
            <Text className={styles.description}>
              Cette option permet de gérer les pièces partagées entre plusieurs
              locataires, très utile dans le cas d'une colocation.
              <br />
              Par exemple pour une salle de bain partagée, créez une pièce et
              cochez la case "ceci est une pièce partagée", en haut du
              formulaire. Une fois cochée, vous pourrez ajouter cette pièce sur
              chacun de vos "biens" en la selectionnant dans le menu ci-dessous.
            </Text>
            {availableOptions.length > 0 ? (
              <>
                <ReactSelect name="id" options={availableOptions} />
                <ModalDialogFooter>
                  <FormikSubmitButton requiresWrite>Ajouter</FormikSubmitButton>
                </ModalDialogFooter>
              </>
            ) : (
              <Callout variant="danger">
                Pas de pièce partagée disponible.
                <br />
                Pour en configurer une, ajouter une pièce classique, et cliquez
                sur "partager"
              </Callout>
            )}
          </Form>
        </ModalDialog>
      )}
    </Formik>
  );
}
